export var StepType;
(function (StepType) {
    StepType["Filter"] = "filter";
    StepType["Aggregate"] = "aggregate";
    StepType["JOIN"] = "join";
    StepType["CustomTransform"] = "custom-transform";
    StepType["CustomExpand"] = "custom-expand";
    StepType["Limit"] = "limit";
    StepType["Select"] = "select";
    StepType["Sort"] = "sort";
    StepType["Union"] = "union";
    StepType["History"] = "history";
})(StepType || (StepType = {}));
export var IAggregationType;
(function (IAggregationType) {
    IAggregationType["Sum"] = "sum";
    IAggregationType["Average"] = "average";
    IAggregationType["First"] = "first";
    IAggregationType["Last"] = "last";
    IAggregationType["Min"] = "min";
    IAggregationType["Max"] = "max";
    IAggregationType["CSV"] = "csv";
    IAggregationType["Count"] = "count";
})(IAggregationType || (IAggregationType = {}));
export var IHistoryBucket;
(function (IHistoryBucket) {
    IHistoryBucket["OneMin"] = "1min";
    IHistoryBucket["FiveMin"] = "5min";
    IHistoryBucket["FifteenMin"] = "15min";
    IHistoryBucket["ThirtyMin"] = "30min";
    IHistoryBucket["Hour"] = "hour";
    IHistoryBucket["Day"] = "day";
    IHistoryBucket["Week"] = "week";
    IHistoryBucket["Month"] = "month";
    IHistoryBucket["Year"] = "year";
})(IHistoryBucket || (IHistoryBucket = {}));
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["SQL"] = "sqltable";
    DataSourceType["COLLECTION"] = "collection";
    DataSourceType["WORKFLOW"] = "lucy";
    DataSourceType["JSON"] = "json";
    DataSourceType["DX"] = "dx";
    DataSourceType["Query"] = "query";
})(DataSourceType || (DataSourceType = {}));
